import { render, staticRenderFns } from "./SubGroupEdit.vue?vue&type=template&id=54595660&scoped=true&"
import script from "./SubGroupEdit.vue?vue&type=script&lang=js&"
export * from "./SubGroupEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54595660",
  null
  
)

export default component.exports